import { ThemeProvider } from "@mui/material";
import { QueryClientProvider } from "react-query";
import ptBR from "date-fns/locale/pt-BR";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AuthProvider } from "./Auth";
import { ToastProvider } from "./Toast";
import { AudienceProvider } from "./Audience";
import { NotificationProvider } from "./Notification";
import { configureDesignSystem } from "../theme/designSystem";
import { queryClient } from "../services/queryClient";
import { AwsProvider } from "./Aws";
import { DialogConfirmationProvider } from "./DialogConfirmation";

type AppProviderProps = {
  children: React.ReactNode;
};

export function AppProvider({ children }: AppProviderProps) {
  return (
    <LocalizationProvider adapterLocale={ptBR} dateAdapter={AdapterDateFns}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={configureDesignSystem}>
          <DialogConfirmationProvider>
            <ToastProvider>
              <NotificationProvider>
                <AwsProvider>
                  <AudienceProvider>
                    <AuthProvider>{children}</AuthProvider>
                  </AudienceProvider>
                </AwsProvider>
              </NotificationProvider>
            </ToastProvider>
          </DialogConfirmationProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </LocalizationProvider>
  );
}
